export { default as WGSearchBar } from './svelte/SearchBar';
